<ng-template dsListableObject></ng-template>
